import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Configuration from "@/pages/Configuration";
import Integrations from "@/pages/Integrations";
import AuditLog from "@/pages/AuditLog";
import PrivacyRequests from "@/pages/PrivacyRequests";
import PushNotifications from "@/pages/PushNotifications";
import BlobManager from "@/pages/BlobManager";
import SsoDashboard from "@/pages/SsoDashboard";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground animate-pulse">
          Initializing Forge…
        </div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Overview />} />
        <Route path="privacy" element={<PrivacyRequests />} />
        <Route path="push" element={<PushNotifications />} />
        <Route path="storage" element={<BlobManager />} />
        <Route path="configuration" element={<Configuration />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="audit" element={<AuditLog />} />
        <Route path="sso-dashboard" element={<SsoDashboard />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster theme="dark" position="top-right" />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
